export const PebbleMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" data-testid="pebble-logo-mark">
    <ellipse cx="32" cy="44" rx="22" ry="9" fill="#7C8B6F" />
    <ellipse cx="32" cy="34" rx="16" ry="8" fill="#B4552A" />
    <ellipse cx="32" cy="25" rx="10" ry="6" fill="#2A2521" />
    <path d="M14 52c6 3 30 3 36 0" stroke="#B4552A" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.5" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <a href="#top" className="flex items-center gap-2.5" data-testid="brand-logo-link" aria-label="Pebble Farms — back to top">
    <PebbleMark />
    <span className="leading-tight">
      <span className={`block font-serif text-lg font-semibold ${dark ? "text-cream" : "text-charcoal"}`}>Pebble Farms</span>
      <span className={`hidden sm:block text-[10px] uppercase tracking-[0.18em] ${dark ? "text-cream/70" : "text-soft"}`}>
        by Elite STR Hosting Co.
      </span>
    </span>
  </a>
);
